import React from "react";
import { ConnectExternalAccountStep } from "@shared/features/configuration/types";
import { ExternalInvitationUserData } from "@shared/types";

export const ExternalConnectAccountContext = React.createContext<
  | {
      isExternalConnectAccount?: boolean;
      accountName?: string;
      token?: string;
      exchange?: string;
      step: ConnectExternalAccountStep | undefined;
      isError?: boolean;
      errorMessage?: string;
      isWhitelabel?: boolean;
      hasReadAccess?: boolean;
      inviteData: ExternalInvitationUserData | undefined;
      isUserLinkedToAnotherManager: boolean;
      isUserWithDifferencePermission: boolean;
      isUserNotSubUser: boolean;
      handleAuthCompleted: () => void;
      handleUserConfirmed: (userId?: number) => void;
      hideQuickConnect?: boolean | null;
    }
  | undefined
>(undefined);
